// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"3cb241f0","793":"e22235e4"}[chunkId] + ".chunk.css";
};